import { getSystemTheme, applyThemeToDocument, onSystemThemeChange } from '@/utils/themeUtils'

const state = {
  currentTheme: 'light',
}

const getters = {
  isDarkTheme: s => s.currentTheme === 'dark',
  isLightTheme: s => s.currentTheme === 'light',
}

const mutations = {
  SET_THEME(s, theme) {
    s.currentTheme = theme
  },
}

const actions = {
  initializeTheme({ commit }) {
    // Check for saved preference, otherwise use system theme
    const savedTheme = localStorage.getItem('theme')
    const theme = savedTheme || getSystemTheme()
    commit('SET_THEME', theme)
    applyThemeToDocument(theme)

    // Listen for system theme changes (only if no manual preference saved)
    onSystemThemeChange(newTheme => {
      if (!localStorage.getItem('theme')) {
        commit('SET_THEME', newTheme)
        applyThemeToDocument(newTheme)
      }
    })
  },

  setTheme({ commit }, theme) {
    commit('SET_THEME', theme)
    applyThemeToDocument(theme)
    localStorage.setItem('theme', theme)
  },

  clearThemePreference({ commit }) {
    localStorage.removeItem('theme')
    const theme = getSystemTheme()
    commit('SET_THEME', theme)
    applyThemeToDocument(theme)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
